import { Link } from "react-router-dom";
import { useState } from "react";
import "./footerPanel.css";
import {
  MdHome,
  MdShoppingBasket,
  MdShoppingBag,
  MdOutlineSearch,
} from "react-icons/md";
import { HiUserCircle } from "react-icons/hi";
// import { Search } from "@mui/icons-material";

const FooterPanel = () => {
  // const nav = useNavigate();
  const [home, setHome] = useState(true);
  const [order, setOrder] = useState(false);
  const [profile, setProfile] = useState(false);
  const [basket, setBasket] = useState(false);
  const [search, setSearch] = useState(false);

  return (
    <div className="a-footer">
      <Link
        to="/home"
        onClick={() => {
          setHome(true);
          setOrder(false);
          setProfile(false);
          setBasket(false);
          setSearch(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
        className={home ? "a-btn-active" : ""}
      >
        <p
          style={{
            margin: "0",
          }}
        >
          <MdHome fill="var(--primary-color)" size={20} />
        </p>
        Home
      </Link>
      <Link
        to="/order"
        onClick={() => {
          setHome(false);
          setOrder(true);
          setProfile(false);
          setBasket(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
        className={order ? "a-btn-active" : ""}
      >
        <p
          style={{
            margin: "0",
          }}
        >
          <MdShoppingBasket fill="var(--primary-color)" size={20} />
        </p>
        Orders
      </Link>
      <Link
        to="/basket"
        onClick={() => {
          setHome(false);
          setOrder(false);
          setProfile(false);
          setBasket(true);
          setSearch(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
        className={basket ? "a-btn-active" : ""}
      >
        <p
          style={{
            margin: "0",
          }}
        >
          <MdShoppingBag fill="var(--primary-color)" size={20} />
        </p>
        Basket
      </Link>
      <Link
        to="/profile"
        onClick={() => {
          setHome(false);
          setOrder(false);
          setProfile(true);
          setBasket(false);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
        className={profile ? "a-btn-active" : ""}
      >
        <p
          style={{
            margin: "0",
          }}
        >
          <HiUserCircle fill="var(--primary-color)" size={20} />
        </p>
        Profile
      </Link>
      {/* <Link
        to="/search"
        onClick={() => {
          setHome(false);
          setOrder(false);
          setProfile(false);
          setBasket(false);
          setSearch(true);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
        className={search ? "a-btn-active" : ""}
      >
        <p
          style={{
            margin: "0",
          }}
        >
          <MdOutlineSearch fill="var(--primary-color)" size={20} />
        </p>
        Search
      </Link> */}
    </div>
  );
};

export default FooterPanel;
